import { Box, Grid } from "@mui/material";
import Button from "../../../components/Button";
import { useStyles } from "./styles";
import SettingsIcon from "@mui/icons-material/Settings";
import AppsIcon from "@mui/icons-material/Apps";
import PublicIcon from "@mui/icons-material/Public";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import ApartmentIcon from "@mui/icons-material/Apartment";
import CryptoOfferingCard from "../../../components/CryptoOfferingCard";
import CryptoOfferingArticle from "../../../components/CryptoOfferingArticle";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";

import ImgCurrencyGraph from "../../../assets/images/products/currency-graph.svg";
import ImgOtherBg from "../../../assets/images/products/Backgroundsection.svg";
import PageHero from "../../../components/PageHero";

const CARDS = [
  {
    id: 0,
    icon: <SettingsIcon />,
    title: "Range of Strategies",
    content: "Size, sector, thematic, quantitative, ESG...",
  },
  {
    id: 1,
    icon: <AppsIcon />,
    title: "Broad Coverage",
    content: "Universe of more than 1000 tokens.",
  },
  {
    id: 2,
    icon: <PublicIcon />,
    title: "Data Expertise",
    content: "Cleansed, normalized, reference and market data.",
  },
  {
    id: 3,
    icon: <MenuBookIcon />,
    title: "EU Benchmark Regulation",
    content:
      "As a BMR administrator, our indexes are fully compliant with BMR and IOSCO.",
  },
  {
    id: 4,
    icon: <ApartmentIcon />,
    title: "Institutional-grade  fixings",
    content: "Customizable fixing timings and methodologies.",
  },
];

const ARTICLES = [
  {
    id: 0,
    title: "BITA Crypto 10",
    link: "#",
  },
  {
    id: 1,
    title: "BITA Crypto Decentralized Finance Index",
    link: "#",
  },
  {
    id: 2,
    title: "BITA Crypto Metaverse Index",
    link: "#",
  },
  {
    id: 3,
    title: "BITA Crypto Smart Contract Platforms Index",
    link: "#",
  },
  {
    id: 4,
    title: "BITA Crypto Next 20 Index",
    link: "#",
  },
  {
    id: 5,
    title: "BITA Bitcoin Zero Carbon Index",
    link: "#",
  },
];

const CryptoOffering = () => {
  const classes = useStyles();

  return (
    <Box className={classes.root}>
      <PageHero
        colorScheme="gray"
        mainContentColorScheme="dark"
        title="BITA Crypto Index Offering"
        subTitle="Empower your cryptocurrency strategies."
        extraElement={
          <Box>
            <Button label="Contact Us" onClick={() => true} />
          </Box>
        }
      />

      <Box className={classes.main}>
        <Box>
          <Box className={classes.mainHeading}>Pioneering on Crypto</Box>
          <Box className={classes.mainText} mt={3}>
            One of the world's first crypto indexers, BITA offers the world's
            widest coverage of crypto indexes and strategies. From traditional
            size indexes to sectorial and thematic strategies, we help global
            institutions to launch unique, innovative investment products.
          </Box>
        </Box>

        <Grid className={classes.sectionContainer} container spacing={2}>
          {CARDS.map((card) => (
            <Grid key={card.id} item xs={12} sm={4}>
              <CryptoOfferingCard {...card} />
            </Grid>
          ))}
        </Grid>
      </Box>

      <Box className={classes.main}>
        <Box>
          <Box className={classes.mainHeading}>
            BITA Crypto Data · Consolidated Feeds
          </Box>
          <Box className={classes.imgContainer}>
            <img src={ImgCurrencyGraph} alt="Currency graph" />
          </Box>
        </Box>
      </Box>

      <Box className={classes.main}>
        <Box>
          <Box className={classes.mainHeading}>BITA Cryptocurrency Indexes</Box>
        </Box>
        <Grid className={classes.sectionContainer} container spacing={6}>
          {ARTICLES.map((article) => (
            <Grid key={article.id} item xs={12} sm={4}>
              <CryptoOfferingArticle {...article} />
            </Grid>
          ))}
        </Grid>

        <Box pb={12}>
          <Box
            className={classes.bottomSectionInner}
            sx={{
              backgroundImage: `url(${ImgOtherBg})`,
            }}
          >
            <Box className={classes.mainHeading}>Other Crypto Data</Box>
            <Box className={classes.bottomSectionText}>
              BITA’s Cryptocurrency Data will be available for the most widely
              and actively traded cryptocurrencies in the market and exchanges
              around the globe. Stay tuned for the upcoming updates about this
              product.
            </Box>
            <Box className={classes.bottomSectionLink}>
              <ChevronRightIcon />
              Suscribe to Newsletter
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default CryptoOffering;
